import { render } from "./KitchenDisplay.vue?vue&type=template&id=2da1e1d7&scoped=true"
import script from "./KitchenDisplay.vue?vue&type=script&lang=js"
export * from "./KitchenDisplay.vue?vue&type=script&lang=js"

import "./KitchenDisplay.vue?vue&type=style&index=0&id=2da1e1d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da1e1d7"]])

export default __exports__